export const COST_CENTER_SEGMENT_NAME = 'cost_center';
export const PRODUCT_LINE_SEGMENT_NAME = 'product_line';

export const COST_CENTER_CODE_SEGMENT_NAME = 'cost_center_code';
export const PRODUCT_LINE_CODE_SEGMENT_NAME = 'product_code';

export enum CorpSegmentNames {
  COST_CENTER = 'Cost Center',
  COST_CENTER_DESCRIPTION = 'Cost Center Description',
  PRODUCT_LINE = 'Product Line',
  PRODUCT_LINE_DESCRIPTION = 'Product Line Description',
  PROJECT = 'Project',
  ACCOUNT = 'Account',
  ACCOUNT_DESCRIPTION = 'Account Description',
  CHANNEL = 'Channel',
  LOCATION = 'Location',
  COMPANY = 'Company',
  COMPANY_DESCRIPTION = 'Company Description'
}

export enum BusinessSegmentNames {
  EXPENSE_TYPE = 'Expense Type',
  COMMODITY = 'Commodity'
}

export enum SegmentCategoryType {
  CORP = 'CORP',
  BUSINESS = 'BUSINESS'
}

/**
 * Checks if a corporate segment is mandatory for business group configuration.
 * After adding Currency (Local / USD), COMPANY is a mandatory section along with COST_CENTER.
 *
 * @param corpSegmentName - The corporate segment name to check
 * @returns true if the segment is mandatory, false otherwise
 * @feature Currency (Local / USD)
 * @since 2025.1.0
 * @modified 2025-07-13 - Added COMPANY as mandatory segment for Currency feature
 */
export const isMandatoryCorpSegment = (corpSegmentName: CorpSegmentNames): boolean => {
  return corpSegmentName === CorpSegmentNames.COST_CENTER || corpSegmentName === CorpSegmentNames.COMPANY;
};

// Adding the definition of the sequence of corp segments to display on the Onboarding page, ensuring consistent ordering regardless of the backend response.
export const CORP_SEGMENTS_SEQUENCE: CorpSegmentNames[] = [
  CorpSegmentNames.COST_CENTER,
  CorpSegmentNames.PRODUCT_LINE,
  CorpSegmentNames.ACCOUNT,
  CorpSegmentNames.PROJECT,
  CorpSegmentNames.CHANNEL,
  CorpSegmentNames.LOCATION,
  CorpSegmentNames.COMPANY
];
